import type { DropdownMenuProps } from "@radix-ui/react-dropdown-menu";
import React from "react";

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
} from "@/components/plate-ui/dropdown-menu";
import { ToolbarButton } from "@/components/plate-ui/toolbar";
import { useOpenState } from "@/hooks/useOpenState";
import { FeedRecordPreset, recordTypes } from "@/routes/game-feed/types";
import { cn } from "@/utils";

const items = [
    { label: "Default", value: "default" },
    ...Object.entries(recordTypes).map(([value, type]) => ({
        label: type.title,
        value: value,
    })),
];

export default function FeedRecordTypeDropdownMenu(
    props: DropdownMenuProps & {
        value: FeedRecordPreset | null;
        onValueChange: (val: FeedRecordPreset | null) => void;
    }
) {
    const openState = useOpenState();

    const selectedItem = React.useMemo(
        () => items.find(item => item.value === props.value) ?? items[0],
        [props.value]
    );

    return (
        <DropdownMenu {...openState} {...props}>
            <DropdownMenuTrigger asChild>
                <ToolbarButton
                    pressed={openState.open}
                    tooltip="Preset"
                    isDropdown
                    className={cn(selectedItem.value === "default" ? "text-gray-400" : "")}
                >
                    {selectedItem.label}
                </ToolbarButton>
            </DropdownMenuTrigger>

            <DropdownMenuContent className="ignore-click-outside/toolbar min-w-[180px]" align="end">
                <DropdownMenuRadioGroup
                    value={props.value ?? "default"}
                    onValueChange={type => {
                        console.log("value changed", type);
                        props.onValueChange(type === "default" ? null : (type as FeedRecordPreset));
                    }}
                    label="Select preset"
                >
                    {items.map(({ label, value: itemValue }) => (
                        <DropdownMenuRadioItem
                            key={itemValue}
                            className="min-w-[180px]"
                            value={itemValue}
                        >
                            {label}
                        </DropdownMenuRadioItem>
                    ))}
                </DropdownMenuRadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
